<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer011">
<p class="epigraph">“Those who cannot remember the past are condemned to repeat it.”</p>
<p class="epigraph-right-space-after">—George Santayana</p>
<p class="epigraph-right-space-after"> </p>
<p class="epigraph">“That men do not learn very much from the lessons of history is the most important of all the lessons of history.”</p>
<p class="epigraph-right-space-after"><a id="_idTextAnchor000"></a>—Aldous Huxley</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KnifeRiver_5P2.vue?4dbd5cfa